const initialState = false;

const clickDetection3 = (state = initialState, action) => {
    switch (action.type) {
        case "DETECTION3":
            return (state = action.payload);
        default:
            return state;
    }
};

export default clickDetection3;
